import React, { useState, useEffect, useRef  } from 'react';
import { Document, Page,pdfjs } from 'react-pdf';


export default function PDFRenderer({ pdfUrl }) {
    pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
    const [pageNumber, setPageNumber] = useState(1);
    const [containerWidth, setContainerWidth] = useState(0);
    const containerRef = useRef(null); 
  
    useEffect(() => {
      const updateWidth = () => {
        if (containerRef.current) {
          setContainerWidth(containerRef.current.offsetWidth); 
        }
      };
  
      const resizeObserver = new ResizeObserver(() => {
        updateWidth();
      });
  
      if (containerRef.current) {
        resizeObserver.observe(containerRef.current); 
        updateWidth();
      }
  
      return () => {
        if (containerRef.current) {
          resizeObserver.unobserve(containerRef.current);
        }
      };
    }, []);
    

    function onDocumentLoadSuccess() {   
    setPageNumber(1);
    }

  return (
    <>
    <div ref={containerRef} style={{ width: "100%", height: "100%" }}>
      <Document
        file={pdfUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<div style={{textAlign: "center"}}><div className="spinner" style={{backgroundColor:"rgba(0, 0, 0, 0)"}}></div></div>}
        >
        <Page pageNumber={pageNumber} loading={null} 
          renderTextLayer={false} 
          renderAnnotationLayer={false} 
          width={containerWidth} 
          renderMode="canvas"
          canvasBackground='#f8f5ef'
        />
      </Document>
     </div>
    </>
  );
}